import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UpdateInsuranceDetails } from '@/@types/insurance';
import { getInsuranceDetails, updateInsuranceDetails } from '@/api/insurance/insurance';

export const useGetInsuranceDetails = (isEntitled: boolean = false) => {
  const { isLoading, isFetching, data, isError, isSuccess } = useQuery({
    queryKey: ['insurance-details'],
    queryFn: getInsuranceDetails,
    enabled: isEntitled,
  });

  return {
    initializing: isLoading || isFetching,
    insuranceDetails: data,
    isInsuranceDetailsSuccess: isSuccess,
    isInsuranceDetailsError: isError,
  };
};

export const useUpdateInsuranceDetails = (insuranceNumber: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isLoading, isError } = useMutation(
    ({ insuranceDetails }: { insuranceDetails: UpdateInsuranceDetails }) =>
      updateInsuranceDetails(insuranceNumber, insuranceDetails),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['insurance-details']);
      },
    },
  );
  return {
    mutate: mutateAsync,
    isSuccess,
    isLoading,
    isError,
  };
};
